<!-- 注册报到 -->
<template>
  <div class="online-report">
    <div class="title">
      <h2 class="fl">三四六级语言考试申请</h2>
      <button class="fr upload-btn" @click="openDio">考试申请</button>
    </div>

    <!-- <h2 class="title">注册报到</h2> -->
    <!-- <div class="result-main">
      <div class="demand-box">
        <p>请输入姓名:</p>
        <div class="input-box">
          <input type="text" id="inputs" v-model="name" />
        </div>
      </div>
      <div class="demand-box">
        <p>请输入身份证号:</p>
        <div class="input-box">
          <input type="number" id="inputs" v-model="idcard" />
        </div>
      </div>
      <div class="submit-div">
        <button @click="fetchData" class="submit-btn">报到</button>
      </div>
    </div> -->

    <div class="app-main" v-if="dataList.length > 0">
      <div class="main-title">
        <span>姓名</span>
        <span>学号</span>
        <span>报考学校</span>
        <span>语种</span>
        <span>等级</span>
        <span>审核状态</span>
      </div>
      <div class="main-conent" v-for="(item, index) in dataList" :key="index">
        <span>{{ item.name || "未知" }}</span>
        <span>{{ item.studentsn || "未知" }}</span>
        <span>{{ item.school }}</span>
        <span>英语</span>
        <span v-if="item.level === 1">三级</span>
        <span v-else-if="item.level === 2">四级</span>
        <span v-else>六级</span>
        <span class="look">{{ sendType(item.status) }}</span>
      </div>
    </div>

    <el-dialog
      title="在线报到注册表"
      :visible.sync="centerDialogVisible"
      width="920px"
      center
      class="dialog3"
    >
      <div class="concent1">
        <el-form ref="form" :model="form" label-width="120px">
          <div class="fl" style="width: 50%">
            <el-form-item label="学号">
              <el-input
                v-model="form.studentsn"
                placeholder="请输入学号"
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-select v-model="form.sex" placeholder="请选择性别">
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报考学校">
              <el-select
                v-model="form.school"
                placeholder="请选择报考学校"
                @change="handleChange"
              >
                <el-option
                  :label="item.name"
                  :value="item.name"
                  v-for="(item, index) in schoolList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年级">
              <el-input
                v-model="form.grade"
                placeholder="请输入年级"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input
                v-model="form.idcard"
                placeholder="请输入身份证号"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="专业">
              <el-select v-model="form.subject" placeholder="请选择专业">
                <el-option
                  :label="item.name"
                  :value="item.id"
                  v-for="(item, index) in disciplineList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="联系方式">
              <el-input
                v-model="form.mobile"
                placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>
          </div>
          <div class="fl" style="width: 50%">
            <el-form-item label="学历">
              <el-input
                v-model="form.study_level"
                placeholder="请输入学历"
              ></el-input>
            </el-form-item>
            <el-form-item label="班级">
              <el-input
                v-model="form.class"
                placeholder="请输入班级"
              ></el-input>
            </el-form-item>

            <el-form-item label="专业">
              <el-input
                v-model="form.subject"
                placeholder="请输入专业"
              ></el-input>
            </el-form-item>

            <!-- <el-form-item label="报到时间">
              <el-date-picker
                type="date"
                placeholder="请选择报到时间"
                v-model="form.report_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item> -->
            <el-form-item label="报考语种">
              <!-- <el-select
                v-model="form.language"

                placeholder="请选择报考语种"
              >
                <el-option label="英语" :value="1"></el-option>
                <el-option label="日语" :value="2"></el-option>
              </el-select> -->

              <el-radio-group v-model="form.language">
                <el-radio disabled :label="1">英语</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="报考等级">
              <el-select v-model="form.level" placeholder="请选择报考等级">
                <el-option label="三级" :value="1"></el-option>
                <el-option label="四级" :value="2"></el-option>
                <el-option label="六级" :value="3"></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="新生转专业">
              <el-input
                v-model="form.change_subject"
                placeholder="请输入新生转专业"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item label="是否缴费">
              <el-select
                v-model="form.is_charge"
                @change="handleChange1"
                placeholder="请选择是否缴费"
              >
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item> -->

            <!-- <el-form-item label="缴费时间" v-if="typeOn"
              ><el-date-picker
                type="date"
                placeholder="请选择缴费时间"
                v-model="form.charge_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item> -->

            <el-form-item
              label="照片"
              style="width: 100%; overflow: hidden; margin-bottom: 10px"
            >
              <!-- <el-input
                v-model="form.charge_img"
                placeholder="请选择上传缴费截图"
              ></el-input> -->
              <el-button
                type="primary"
                @click.stop="uploadHeadImg"
                style="display: inline-block"
                >上传</el-button
              >
              <input
                type="file"
                ref="upload"
                accept="image/*"
                @change="handleFile($event)"
                class="hiddenInput"
              />
              <span
                type="text"
                style="
                  display: inline-block;
                  width: 95%;
                  cursor: pointer;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  word-break: break-all;
                "
                v-if="form.img != ''"
                @click="onLook"
                >{{ form.img }}</span
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">报到</el-button>
              <el-button @click="centerDialogVisible = false">取消</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSchoolList, getSubjectList, uploadImg } from "@/api/home";
import { Message } from "element-ui";
import encrypt from "../utils/encrypt";
import { submitPltApply, getStudentPltApplyList } from "@/api/common";
import { getToken, getUid } from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      centerDialogVisible: false,
      idcard: "",
      name: "",
      typeOn: false,
      dataList: [],
      disciplineList: [],
      schoolList: "",
      form: {
        name: "",
        studentsn: "",
        sex: 1,
        language:1,
        idcard: "",
        grade: "",
        img: "",
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onLook() {
      window.open(this.form.img, "_blank");
    },
    uploadHeadImg() {
      this.$refs.upload.click();
    },
    handleFile(e) {
      let that = this;
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      uploadImg(formData).then((res) => {
        this.$message.success("上传成功");
        this.form.img = res.data;
      });
    },
    handleChange1(val) {
      if (val == 1) {
        this.typeOn = true;
      } else {
        this.typeOn = false;
      }
    },
    handleChange(val) {
      let params = {
        page: 1,
        school_id: val,
      };
      getSubjectList(params).then((response) => {
        this.disciplineList = response.data;
      });
    },
    getSchoolList() {
      getSchoolList().then((response) => {
        this.schoolList = response.data;
      });
    },
    openDio() {
      this.centerDialogVisible = true;
      this.typeOn = false;
      this.form = {
        name: "",
        studentsn: "",
        sex: 1,
        language: 1,
        idcard: "",
        grade: "",
        img: "",
      };
    },
    sendType(val) {
      if (val == 0) {
        return "未审核";
      } else {
        return "已审核";
      }
    },
    fetchData2() {
      let token = getToken();
      let uid = getUid();
      console.log(uid);
      let data = {
        uid: uid,
        page: 1,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      console.log("p", params);
      getStudentPltApplyList(params).then((response) => {
        console.log("p", response);
        if (response.data) {
          this.dataList = response.data;
        }
      });
    },
    onSubmit() {
      let token = getToken();
      let uid = getUid();
      let data = {
        uid: uid,
        ...this.form,
        // name: this.form.name,
        // sex: this.form.sex,
        // studentsn: this.form.studentsn,
        // idcard: this.form.idcard,
        // school_id: this.form.school_id,
        // grade: this.form.grade,
        // subject_id: this.form.subject_id,
        // educational_level: this.form.educational_level,
        // change_subject: this.form.change_subject,
        // report_time: this.form.report_time,
        // is_charge: this.form.is_charge,
        // charge_time: this.form.charge_time,
        // charge_img: this.form.charge_img,
      };
      console.log("d", data);
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      submitPltApply(params)
        .then((response) => {
          this.centerDialogVisible = false;
          this.fetchData2();
          this.$message.success("报到成功");
        })
        .catch((error) => {
          Message({
            message: error.msg,
            type: "error",
            duration: 3 * 1000,
          });
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData2();
    this.getSchoolList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>

<style lang="scss">
.dialog3 {
  .concent1 {
    padding-top: 35px;
    // padding-bottom: 80px;
    // padding-left: 75px;
    height: 615px;
  }
  .el-form-item {
    width: 300px;
  }
  .el-select,
  .el-input,
  .el-input__inner {
    width: 220px;
  }
  .el-form-item__label {
    line-height: 3em;
  }
}
.dialog9 {
  .concent1 {
    padding-top: 35px;
    // padding-bottom: 80px;
    // padding-left: 75px;
    height: 275px;
  }
}
</style>
<style lang="scss" scoped>
.online-report {
  min-width: 650px;
}
.title {
  padding-left: 37px;
  padding-right: 60px;
  height: 75px;
  line-height: 75px;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  align-content: center;
  justify-content: space-between;
  h2 {
    font-size: 24px;
    color: #00468e;
    @media screen and (max-width: 1010px) {
      font-size: 20px;
    }
  }

  .upload-btn {
    background-color: #007dc2;
    outline: none;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    width: 150px;
    height: 44px;
    font-size: 16px;
    margin: auto 0;
    cursor: pointer;
    @media screen and (max-width: 1010px) {
      width: 130px;
      font-size: 14px;
    }
  }
}
.title {
  padding-left: 37px;
  padding-right: 60px;
  font-size: 24px;
  color: #00468e;
  height: 75px;
  line-height: 75px;
  border-bottom: 1px solid #ebebeb;
  @media screen and (max-width: 1010px) {
    font-size: 20px;
  }
}
.result-main {
  height: calc(100% - 75px);
  padding-top: 37px;
  padding-left: 37px;
  padding-right: 60px;
  .demand-box {
    height: 150px;
    background-color: #f3f3f3;
    margin-bottom: 30px;
    padding-left: 35px;
    padding-right: 30px;
    padding-top: 28px;
    @media screen and (max-width: 1010px) {
      height: 120px;
      margin-bottom: 30px;
    }
    p {
      font-size: 17px;
      color: #333333;
      margin-bottom: 15px;
      @media screen and (max-width: 1010px) {
        font-size: 15px;
      }
    }
    .input-box {
      height: 65px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media screen and (max-width: 1010px) {
        height: 45px;
      }
      input {
        width: 100%;
        height: 100%;
        outline: none;
        border: none;
        font-size: 25px;
      }
      button {
        width: 215px;
        height: 100%;
        outline: none;
        border: none;
        background-color: #007dc2;
        color: #ffffff;
        font-size: 18px;
        text-align: center;
        line-height: 65px;
        cursor: pointer;
      }
    }
  }
  .submit-div {
    width: 100%;
    display: flex;
    justify-content: center;
    @media screen and (max-width: 1010px) {
      height: 50px;
    }
    .submit-btn {
      margin: 0 auto;
      width: 315px;
      height: 100%;
      outline: none;
      border: none;
      background-color: #007dc2;
      color: #ffffff;
      font-size: 18px;
      text-align: center;
      line-height: 65px;
      cursor: pointer;
      @media screen and (max-width: 1010px) {
        line-height: 50px;
        width: 100%;
      }
    }
  }
}

.app-main {
  height: calc(100% - 75px);
  padding-top: 37px;
  padding-left: 37px;
  padding-right: 60px;
  .main-title {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 100px;
    grid-template-rows: 27px;
    font-size: 15px;
    color: #000000;
    border-bottom: 1px solid #d7d7d7;
    span {
      padding-left: 9px;
    }
  }
  .main-conent {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 100px;
    grid-template-rows: 48px;
    line-height: 48px;
    font-size: 15px;
    color: #999999;
    border-bottom: 1px solid #d7d7d7;
    overflow: hidden;
    span {
      padding-left: 9px;
    }
    .look {
      color: #007dc2;
      cursor: pointer;
    }
  }
}

.hiddenInput {
  display: none;
}
</style>
